import React, { useState, useEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { useLocation } from '@reach/router';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import ArrowTop from '../../images/SideNavAndStatus/inline-svg/arrow-top.svg';
import { mobileMQ } from './media-utils';

const Wrapper = styled.div`
    position: ${({ isFixed }) => (isFixed ? 'fixed' : 'absolute')};
    left: 4%;
    top: ${({ isFixed }) => (isFixed ? '15%' : '60vh')};
    z-index: 100;

    ${mobileMQ(css`
        display: none;
    `)}
`;

const NavigationBar = styled.div`
    background: #fff;
    box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 7px 20px 7px 12px;
    transition: padding 0.5s;
    overflow: hidden;
    & a {
        transition: max-width 0.3s ease;
        max-width: ${props => (props.isOpen ? '300px' : '0px')};
    }
`;

const StyledAnchorLink = styled(AnchorLink)`
    width: 100%;
    white-space: nowrap;
    display: inline-block;
    color: ${props => (props.isActive ? '#0b9cdb' : 'black')};
    &:before {
        content: '';
        display: inline-block;
        border-radius: 100px;
        width: 8px;
        height: 8px;
        margin-right: 0.8rem;
        background-color: ${props => (props.isActive ? '#0b9cdb' : 'black')};
    }
    &:hover {
        color: #0b9cdb;

        @media (pointer: fine) {
            &:before {
                background-color: #0b9cdb;
            }
        }
    }
`;

const Menu = styled.ul`
    position: relative;
    font-family: 'Circe Web';
    font-size: 14px;
    color: black;
    line-height: 1.8;
    list-style: none;
`;

const StyledAnchorArrow = styled(AnchorLink)`
    width: 14px;
    height: 14px;
    background-color: #fff;
    border-radius: 16px;
    padding: 9px;
    display: block;
    line-height: 14px;
    margin-top: 16px;

    svg {
        display: inline-block;
        margin-top: -7px;
        width: 100%;
        height: 100%;
    }
`;

const TopPoint = styled.div`
    position: absolute;
    top: 0;
`;

export const SideNavAndStatus = ({ refsSet }) => {
    const [openBar, setOpenBar] = useState(false);
    const [barFixed, setBarFixed] = useState(false);
    const [show, setShow] = useState(null);
    const [navData, setNavData] = useState([]);

    const { pathname } = useLocation();

    const innerWidth = typeof window !== 'undefined' && window.innerWidth;

    useEffect(() => {
        if (refsSet) {
            setNavData(
                [...refsSet].map(item => {
                    return {
                        text: item.innerText,
                        id: item.id,
                        pos: item.getBoundingClientRect().top + window.scrollY,
                    };
                })
            );
        }
    }, [refsSet, innerWidth]);

    const onScroll = useCallback(() => {
        if (window.scrollY > (window.innerHeight / 100) * 45) {
            setBarFixed(true);
        } else {
            setBarFixed(false);
        }

        const scrollPos = window.scrollY + window.innerHeight / 4;

        if (scrollPos === window.innerHeight / 4) {
            setOpenBar(true);
        } else {
            setOpenBar(false);
        }

        const activeItemIndex = navData.findIndex(
            (item, i, array) =>
                (item.pos < scrollPos && i + 1 === array.length) ||
                (item.pos < scrollPos && scrollPos < array[i + 1].pos)
        );

        if (activeItemIndex !== -1) {
            setShow(navData[activeItemIndex].id);
        } else {
            setShow(null);
        }
    }, [navData]);

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [onScroll]);

    const onMouseEnter = useCallback(() => {
        setOpenBar(true);
    }, []);

    return (
        <React.Fragment>
            <TopPoint id="top" />
            <Wrapper isFixed={barFixed}>
                <NavigationBar isOpen={openBar} onMouseEnter={onMouseEnter}>
                    <Menu>
                        {navData &&
                            navData.map(({ text, id }) => {
                                return (
                                    <li key={id}>
                                        <StyledAnchorLink
                                            to={`${pathname}#${id}`}
                                            isActive={show === id}
                                        >
                                            {text}
                                        </StyledAnchorLink>
                                    </li>
                                );
                            })}
                    </Menu>
                </NavigationBar>
                <StyledAnchorArrow to={`${pathname}#top`}>
                    <ArrowTop />
                </StyledAnchorArrow>
            </Wrapper>
        </React.Fragment>
    );
};
